module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro-norming.a0333c68.mp3";